<template>
  <div class="container">
    <filter-wrapper :filter-item="{dateRange: true}" class="header" size="mini"></filter-wrapper>
    <el-row :gutter="10" class="sub-header">
      <el-col :span="5">
        <el-input v-model="search" placeholder="快速搜索" size="mini"></el-input>
      </el-col>
      <el-col :span="15">
        <el-badge class="mark" :value="count.detected && count.detected.length || 0">
          <el-tag type="primary" size="mini">采集总数</el-tag>
        </el-badge>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="count.backData && count.backData.length || 0">
          <el-tag type="success" size="mini">回测总数</el-tag>
        </el-badge>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="count.unmark && count.unmark.length || 0">
          <el-tag type="warning" size="mini">待标注</el-tag>
        </el-badge>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="filterList.length || 0">
          <el-tag type="success" size="mini">总计</el-tag>
        </el-badge>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-checkbox v-model="showTest">显示测试</el-checkbox>
        <el-button type="text" @click='refresh(true)' size="mini">强制刷新</el-button>
        <!--<span v-if="userGroup === 1000">-->
          <!--<el-button type="primary" :disabled="!selectedRows.length" size="mini" class="btn-inner"-->
                     <!--@click="setUrgent">设为加急-->
        <!--</el-button>-->
        <!--<el-button type="danger" :disabled="!selectedRows.length" size="mini" class="btn-inner" @click="unsetUrgent">-->
          <!--取消加急</el-button>-->
        <!--</span>-->
        <!--<el-radio v-model="showTest" label="true">显示测试</el-radio>-->
      </el-col>
    </el-row>
    <vvTabel :config="tableConfig"
              :data="filterList"
              :height="tableHight"
              :itemHeight="40"
    >
      <template slot-scope="scope" slot="type_slot">
        <el-tag type="primary" size="mini" v-if="scope.row.type === 'detected'">采集</el-tag>
        <el-tag type="warning" size="mini" v-if="scope.row.type === 'backData'">回测</el-tag>
        <el-tag type="success" size="mini" v-if="scope.row.type === 'unmark'">待标注</el-tag>
        <i v-if="scope.row.urgent === '1'" class="el-icon el-icon-ali-fire"></i>
      </template>
      <template slot-scope="scope" slot="eatery_slot">
        {{scope.row.eatery_name}}
      </template>
      <template slot-scope="scope" slot="canteen_slot">
        {{scope.row.canteen_name}}
      </template>
      <template slot-scope="scope" slot="date_slot">
          {{tsToDate(scope.row.day_ts)}}
        </template>
      <template slot-scope="scope" slot="state_slot">
          <el-tag type="success" size="mini" v-if="scope.row.username"><i class="el-icon-loading"></i> 正在审查</el-tag>
          <el-tag type="primary" size="mini" v-else>未审查</el-tag>
        </template>
      <template slot-scope="scope" slot="user_slot">
          {{scope.row.username ? scope.row.username : "-"}}
      </template>
      <template slot-scope="scope" slot="event_slot">
          <span v-if="!scope.row.username">
            <el-button type="text" size="mini" @click="goCheck(scope.row)" v-if="scope.row.type === 'detected'">去审查</el-button>
            <el-button type="text" size="mini" @click="goCheck(scope.row)" v-if="scope.row.type === 'backData'">去纠错</el-button>
            <el-button type="text" size="mini" @click="goCheck(scope.row)" v-if="scope.row.type === 'unmark'">去标注</el-button>
          </span>
          <span v-else-if="isSelfChecking(scope.row)">
            <el-button type="text" size="mini" @click="goCheck(scope.row)" v-if="scope.row.type === 'detected'">继续审查</el-button>
            <el-button type="text" size="mini" @click="goCheck(scope.row)" v-if="scope.row.type === 'backData'">继续纠错</el-button>
            <el-button type="text" size="mini" @click="goCheck(scope.row)" v-if="scope.row.type === 'unmark'">继续标注</el-button>
          <el-button type="text" size="mini" v-else class="danger-text" @click="cancelCheck(scope.row.label_task_uuid)">取消
          </el-button>
          </span>
          <span v-else>
            <el-button size="mini" type="text" class="danger-text" :disabled="true">其他人正在操作</el-button>
          </span>
        </template>
    </vvTabel>
  </div>
</template>
<script>
import filterWrapper from '_c/filterWrapper';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import moment from 'moment';
import {apiCancelCheck, apiGetAllUserList, apiSetTaskUrgent} from '@/api';
import pinyinMatch from 'pinyin-match';
import vvTabel from 'vue-virtual-table';

export default {
  name: 'taskAdmin',
  components: {
    filterWrapper,
    vvTabel
  },
  data () {
    return {
      selectedRows: [],
      showTest: false,
      search: '',
      markerList: [],
      marker: {},
      showType: [],
      typeList: [
        { label: '采集', value: 'detected' },
        { label: '回测', value: 'backData' }
      ],
      tableConfig: [
        { prop: "_action", name: "类型", actionName: "type_slot", width: 100 },
        { prop: "_action", name: "食堂", actionName: "eatery_slot" },
        { prop: "_action", name: "餐厅", actionName: "canteen_slot" },
        { prop: "_action", name: "生成日期", actionName: "date_slot" },
        { prop: "_action", name: "状态", actionName: "state_slot" },
        { prop: "_action", name: "操作人", actionName: "user_slot" },
        { prop: "_action", name: "操作", actionName: "event_slot" }
      ] };
  },
  created () {
    this.setSubTitle('任务管理');
    this.refresh(false);
    this.showTest = this.$store.state.showTest;
  },
  mounted () {
  },
  methods: {
    ...mapMutations([
      'setSubTitle',
      'setTaskUuid',
      'setShowTest'
    ]),
    // handleClick () {
    //   nprogress.start();
    //   setTimeout(() => {
    //     nprogress.done();
    //   }, 60000);
    // },
    async unsetUrgent () {
      try {
        await apiSetTaskUrgent(this.selectedRows.map(a => a.label_task_uuid), '0');
        this.selectedRows.forEach(a => {
          console.log(a);
          this.$set(a, 'urgent', '0');
        });
        this.$message.warning('设置成功');
      } catch (e) {
        this.$message.error('设置失败');
        console.log(e);
      }
    },
    async setUrgent () {
      if (this.selectedRows.length === 0) {
        return this.$message.error('未选择任务');
      }
      let taskUuidList = this.selectedRows.map(a => a.label_task_uuid);
      try {
        await apiSetTaskUrgent(taskUuidList, '1');
        // this.taskList
        // this.refresh(false);
        // this.$_.find(this.taskList, (a) => {
        //   return a.label_task_uuid ===
        // })
        this.selectedRows.forEach(a => {
          this.$set(a, 'urgent', '1');
        });

        this.$message.warning('加急成功');
      } catch (e) {
        console.log(e);
        this.$message.error('设置失败');
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.urgent === '1') {
        return 'urgent-row';
      }
    },
    ...mapActions([
      'getDetectedUnCheckRemindList',
      'getBackDataUnCheckRemindList',
      'getDataCollectCheckRemind'
    ]),
    async cancelCheck (label_task_uuid) {
      try {
        await apiCancelCheck(label_task_uuid);
        this.setTaskUuid('');
        this.refresh(false);
      } catch (e) {
        this.$message.error(`取消失败: ${e.message}`);
      }
    },
    filterHandler (value, row, column) {
      // console.log(value, row, column);
      const property = column['property'];
      return row[property] === value;
    },
    handleSelected (rows) {
      this.selectedRows = rows;
    },
    assignment () {
      this.$message.error('此功能正在开发中......');
    },
    isSelfChecking (row) {
      let username = this.userinfo().username;
      return username === row.username;
    },
    goCheck (row) {
      let { type, canteen_id, canteen_name, eatery_name, eatery_id, day_ts, label_task_uuid } = row;
      // if (this.userGroup === 1000) {
      //   console.log(this.taskUuid);
      //   this.cancelCheck();
      // } else {
      //   if (this.taskUuid && this.taskUuid !== label_task_uuid) {
      //     return this.$message.error('您有一条任务正在进行中, 请取消或者继续操作');
      //   }
      // }
      this.setTaskUuid(label_task_uuid);
      let dateRange = {
        start_ts: day_ts,
        end_ts: day_ts + 24 * 3600
      };
      if (type === 'detected') {
        // 审查采集数据
        this.$router.push({
          name: 'detectedImageCheck',
          params: {
            checkInfo: row
          }
        });
      } else if (type === 'backData') {
        // return this.$alert('此功能暂有bug暂不开放');
        // 审查回测数据
        this.$router.push({
          name: 'backDataImageCheck',
          params: {
            checkInfo: row
          }
        });
      } else {
        // 标注
        this.$router.push({
          name: 'batchList',
          params: {
            taskInfo: row
          }
          // query: {
          //   canteen: {
          //     canteen_id,
          //     canteen_name
          //   },
          //   eatery: {
          //     eatery_id,
          //     eatery_name
          //   }
          // }
        });
      }
    },
    refresh (isRefresh) {
      let refresh = isRefresh;
      this.getDetectedUnCheckRemindList({ refresh });
      // this.getBackDataUnCheckRemindList({});
      this.getBackDataUnCheckRemindList({ refresh, loadingShow: true });
      this.getDataCollectCheckRemind({ refresh });
    },
    tsToDate (ts) {
      return moment(ts * 1000).format('YYYY-MM-DD');
    },
    async getMarkerList () {
      let res = await apiGetAllUserList(this.apiKey);
      this.markerList = res.user_list.filter((a) => a.user_group === 1 || a.user_group === '1');
    }
  },
  computed: {
    ...mapGetters([
      'taskList',
      'userinfo',
      'taskUuid',
      'listQuery'
    ]),
    tableHight () {
      const clientHeight = window.innerHeight;
      return clientHeight - 80;
    },
    // userinfo1 () {
    //   return this.userinfo();
    // },
    apiKey () {
      return this.userinfo().api_key;
    },
    userGroup () {
      return this.userinfo().userGroup;
    },
    handlerOptions () {
      return {
        key: ''
      };
    },
    filterList () {
      let search = this.search;
      let arr = this.taskList;
      if (!this.showTest) {
        arr = arr.filter(a => {
          return a.canteen_name !== 'test' && a.eatery_name !== '测试';
        });
      }
      if (this.userGroup === 1) {
        arr = arr.filter(a => {
          return a.type !== 'unmark';
        });
      }
      arr.sort((a, b) => {
        return b.urgent - a.urgent;
      });
      return arr.filter(a => {
        let res = pinyinMatch.match(a.canteen_name + ',' + a.eatery_name, search);
        return res.length > 0;
      });
    },
    count () {
      return this.$_.groupBy(this.filterList, 'type');
    }
  },
  watch: {
    // listQuery
    listQuery: {
      handler () {
        this.refresh(false);
      },
      deep: true
    },
    showTest (newVal) {
      this.setShowTest(newVal);
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    position: relative;
    .header-title{
      position: absolute;
      width: 400px;
      top: -45px;
      left: 200px;
    }
    .sub-header{
      height: 40px;
    }
    /*.btn-inner {*/
      /*display: inline-block;*/
    /*}*/
    /*.el-table {*/
      /*background-color: red;*/
    /*}*/
    .el-icon-ali-fire {
      color: red;
    }
    .urgent-row {
      background-color:red;
    }
  }
</style>
